import type { AppRouterClient } from "@fieldwork/api/routers/index";
import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export function createQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        toast.error(`Error: ${error.message}`, {
          action: {
            label: "retry",
            onClick: () => {
              query.invalidate();
            },
          },
        });
      },
    }),
  });
}

export const queryClient = createQueryClient();

export const link = new RPCLink({
  url: `${window.location.origin}/rpc`,
  // A 503 means the panel couldn't reach its database for a moment (it says so itself); retry quietly.
  async fetch(url, options) {
    const init = { ...options, credentials: "include" as const };
    let res = await fetch(url, init);
    for (let attempt = 1; res.status === 503 && attempt <= 2; attempt++) {
      await new Promise((r) => setTimeout(r, 700 * attempt));
      res = await fetch(url, init);
    }
    return res;
  },
});

export const client: AppRouterClient = createORPCClient(link);

export const orpc = createTanstackQueryUtils(client);
